module.exports = __webpack_public_path__ + "static/img/login1.9e750a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login1.png
// module id = UMXo
// module chunks = 1